import URLSearchParams from '@ungap/url-search-params';
import { getApiBaseUrlByTenantCode } from '@tectonics/commons/tenant';
import type { Tenant } from '@tectonics/commons/tenant';
import type { LookAndFeel } from '@tectonics/look-and-feel';
import { getHash } from '@tectonics/prs/incoming-payment';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { UserInputValidationErrors } from '@tectonics/prs/validation';
import { CheckoutFail } from './checkout-fail';

export async function sendCheckoutFailAnalytics(
  incomingPayment: IncomingPayment,
  lookAndFeel: LookAndFeel,
  userInputValues: UserInputValues,
  userInputValidationResult: UserInputValidationErrors,
  tenant: Tenant
): Promise<Response> {
  if (incomingPayment.status !== 'OP') {
    throw new Error('Checkout fail analytics: incoming payment is not opened');
  }

  const hash = getHash(incomingPayment);
  const checkoutFailBody = new CheckoutFail({
    incomingPayment,
    lookAndFeel,
    userInputValues,
    userInputValidationResult,
  });

  return performAnalyticsRequest(checkoutFailBody, tenant, hash);
}

async function performAnalyticsRequest(
  checkoutFail: CheckoutFail,
  tenant: Tenant,
  hash: string,
): Promise<Response> {
  const baseUrl = getApiBaseUrlByTenantCode(tenant.code);
  const path = 'ws/checkout-v2/analytics';
  const params = new URLSearchParams({ hash });
  const placeOrderUrl = `${baseUrl}${path}?${params.toString()}`;

  return fetch(placeOrderUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: checkoutFail.asJSON(),
  });
}
